import React from 'react';
import { Brain, Sparkles } from 'lucide-react';

export const AiProcessingPhase: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-8">
      <div className="bg-white rounded-xl border border-slate-200 p-8">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-2">
            <Sparkles className="w-6 h-6 text-purple-600" />
            <h2 className="text-2xl font-bold text-slate-900">Processing AI Framework</h2>
          </div>
          <p className="text-slate-500 text-sm">
            Building your compliance framework structure...
          </p>
        </div>
        <div className="text-center py-10">
          <div className="flex justify-center mb-6">
            <Brain className="text-blue-600 animate-spin" size={40} />
          </div>
          <p className="text-sm font-medium text-slate-700 mb-4">Synthesizing framework components...</p>
          <div className="w-full max-w-xs mx-auto bg-slate-100 rounded-full h-2 mb-4">
            <div
              className="bg-blue-600 h-2 rounded-full animate-pulse"
              style={{ width: '60%' }}
            ></div>
          </div>
          <p className="text-xs text-slate-500">Applying AI quality checks...</p>
        </div>
      </div>
    </div>
  );
};
